import each from 'lodash-es/each';

let module_name = '';

const extractTableHeadingRow = (row) => {
  const cell_html = [];
  each(row, (cell) => {
    cell_html.push(
      `<th class="Module-${module_name}__Table-Header--Cell" data-size-guide-cell data-size-guide-heading-cell>${cell.c}</th>`,
    );
  });
  const html = `
    <tr class="Module-${module_name}__Table-Header">
      ${cell_html.join('')}
    </tr>
  `;
  return html;
};

const extractTableHeadingBody = (rows) => {
  const body_html = [];
  each(rows, (row) => {
    const row_html = [];
    each(row, (cell, index) => {
      let row_head = '';
      if (index === 0) {
        row_head = `Module-${module_name}__Table-Body--Row--Title`;
      }
      row_html.push(
        `<td class="Module-${module_name}__Table-Body--Cell ${row_head}" data-size-guide-cell data-size-guide-body-cell>${cell.c}</td>`,
      );
    });
    body_html.push(`<tr class="Module-${module_name}__Table-Body--Row">${row_html.join('')}</tr>`);
  });
  const html = `
    ${body_html.join('')}
  `;
  return html;
};

export default (settings, name) => {
  module_name = name;

  const table_heading = extractTableHeadingRow(settings.size_guide.header);
  const table_body = extractTableHeadingBody(settings.size_guide.body);
  const content_html = `
    <div class="Module-${module_name}__SizeGuide">
    <table class="Module-${module_name}__Table" cellspacing="0">
      ${table_heading}
      ${table_body}
    </table>
    </div>
  `;
  return content_html;
};
